(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wcshield-order-bump"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (e) => {
  const row = e.target.closest('[data-wc-bump]');
  if (!row) return;
  const id = row.dataset.wcVariant;
  if (!id) return;
  const isOn = row.getAttribute('aria-pressed') === 'true';
  const routes = (window.Theme && window.Theme.routes) || {};
  const addUrl = (routes.cart_add_url || '/cart/add') + '.js';
  const changeUrl = (routes.cart_change_url || '/cart/change') + '.js';
  const url = isOn ? changeUrl : addUrl;
  const payload = isOn ? { id: id, quantity: 0 } : { id: id, quantity: 1 };
  row.setAttribute('aria-disabled', 'true');
  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify(payload),
  })
    .then((r) => r.json())
    .then(() => {
      const next = !isOn;
      row.setAttribute('aria-pressed', next ? 'true' : 'false');
      row.classList.toggle('is-on', next);
      const live = row.closest('.wcshield-bump__inner').querySelector('.wcshield-bump__live');
      if (live) live.textContent = next ? 'Toegevoegd aan winkelwagen' : 'Verwijderd uit winkelwagen';
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (window.Shopify && window.Shopify.designMode) return;
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.requestUpdate === 'function') drawer.requestUpdate();
    })
    .catch(() => {})
    .finally(() => row.removeAttribute('aria-disabled'));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wcshield-product-hero"] && !Shopify.designMode) return;
  try {
    
class WcshieldGallery extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-wc-slide]'));
    this.thumbs = Array.from(this.querySelectorAll('[data-wc-thumb]'));
    this.index = 0;
    const prev = this.querySelector('[data-wc-prev]');
    const next = this.querySelector('[data-wc-next]');
    if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
    if (next) next.addEventListener('click', () => this.go(this.index + 1));
    this.thumbs.forEach((t) => t.addEventListener('click', () => this.go(parseInt(t.dataset.wcThumb, 10))));
  }
  go(i) {
    if (!this.slides.length) return;
    const n = this.slides.length;
    this.index = ((i % n) + n) % n;
    this.slides.forEach((s, idx) => s.classList.toggle('is-active', idx === this.index));
    this.thumbs.forEach((t, idx) => t.classList.toggle('is-active', idx === this.index));
  }
}
if (!customElements.get('wcshield-gallery')) customElements.define('wcshield-gallery', WcshieldGallery);

document.addEventListener('click', (e) => {
  const tier = e.target.closest('[data-wc-tier]');
  if (!tier) return;
  const form = tier.closest('form');
  const group = tier.closest('.wcshield-tiers');
  if (!group) return;
  group.querySelectorAll('[data-wc-tier]').forEach((b) => {
    const on = b === tier;
    b.classList.toggle('is-selected', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
  const qtyInput = form && form.querySelector('[data-wc-quantity]');
  if (qtyInput) qtyInput.value = tier.dataset.wcTierQty || '1';
});

document.addEventListener('change', (e) => {
  const sel = e.target.closest('[data-wc-variant-select]');
  if (!sel) return;
  const form = sel.closest('form');
  if (!form) return;
  const idInput = form.querySelector('[data-wc-variant-id]');
  if (idInput) idInput.value = sel.value;
  const opt = sel.options[sel.selectedIndex];
  const priceEl = form.closest('.wcshield-hero__info') && form.closest('.wcshield-hero__info').querySelector('[data-wc-price]');
  if (priceEl && opt && opt.dataset.price) priceEl.textContent = opt.dataset.price;
});

  } catch(e) { console.error(e); }
})();
})();
